import './scss/blanks.scss';
import { AssignTasks } from '../../modules/AssignTasks';

import { appConfig as $config } from '../../app.config';
import { Common } from '../../modules/Common';
import { UI } from '../../modules/UI';
import { App } from '../../modules/App';
import { ValidationRules } from '../../modules/ValidationRules';
import { User } from '../../modules/User';

import { SortFilter } from '../../modules/SortFilter';
import { ColorVariants } from '../../modules/ColorVariants';
import { BlankInfo } from '../../modules/BlankInfo';
import { ApprovalRejection } from '../../modules/ApprovalRejection';

export const Blanks = (function () {
  let $needToPromptBulkApprove = false;
  let $showCancelationNotice = false;
  let $defaultSelectedBlankIds = [];
  let $isDetachedFromAccountBlanks = false;
  let $isDTGOnly = false;

  let mapping = {
    blanks: (data, params) => {
      $.each(data, function (key, blank) {
        let variants = [];

        // IF only one checked color
        let lastApproved = blank.variants.filter((f) => f.select).length == 1;

        $.each(blank.variants, function (k, v) {
          let files = _.findWhere(blank.variants, { color: v.color }).files;
          variants.push({
            ...v,
            sizes: v.sizes,
            color: v.color,
            colorHex: v.colorHex,
            imageUri:
              files && files.length && files[0].uri
                ? files[0].uri
                : v.blankVariantAreas && v.blankVariantAreas.length && v.blankVariantAreas[0].file.uri
                ? v.blankVariantAreas[0].file.uri
                : false,
            approved: v.select,
            // Let Color checkbox disable IF in Dialog or this is last checked color
            disabled: params && params.action == 'dialog' ? true : lastApproved && v.select ? true : false
          });
        });

        blank.variants = variants;
        if (blank.variants.length > $config.colorVariantsInCard) {
          blank.variantsLimit = $config.colorVariantsInCard;
          blank.variantsCut = true;
        }
        blank.isDialog = false;
        blank.manufacturers = blank.manufacturingOwners.join(', ');
        blank.sizes = Common.sizeRange(blank.availableSizes);
        blank.createDateText = moment(blank.createdDate).format($config.appFullDateFormat);
        // Approval Item mapping
        blank.approveItem = Common.mapping.approvalObject(blank.approveItem);
        blank.modelImagesText = `${(blank?.photoModels || []).filter((pm) => pm.isSelectCurrentAccount).length}/${
          blank?.photoModels?.length || 0
        }`;
      });
      return data;
    }
  };

  let init = (params = {}, query = '') => {
    if (!params || (params && params.action != 'dialog')) {
      UI.block('#page');
    } else {
      UI.block('.modal-content');
    }

    if (params && params.action && params.id) {
      if (params.action == 'edit') {
        return editPage(params.id);
      } else if (params.action == 'add') {
        return editPage();
      }
    }

    $isDTGOnly = params.isDTGOnly;
    loadData(params, query);
  };

  let loadData = (params = {}, query = '') => {
    let requestData = {
      params: params
    };

    if (params && params.action == 'dialog') {
      $isDetachedFromAccountBlanks = params.isDetachedFromAccountBlanks;
      requestData.requestPage = 'blanks';
      requestData.isExcludeRejected = true;
      if (!params.reload) {
        requestData.page = 1;
      }

      if ($isDTGOnly) {
        requestData.filterItems = [{
          internalName: 'BlankPrintType',
          values: [0]
        }];
      }
    }
    let selectBlanks = App.pageData('selectBlanks') || [];
    let editArtworkBlanksIds = App.pageData('editArtworkBlanksIds') || [];
    let selectBlanksAll = App.pageData('selectBlanksAll') || false;

    $.when(App.ajaxData(
      'blanks/filter',
      requestData,
      'POST',
      'application/json',
      false,
      (responseData) => {
        if (!$isDTGOnly) {
          return responseData;
        }

        const index = responseData?.filterData?.filterItems?.findIndex(i => i?.internalName === 'BlankPrintType');
        if (typeof index === 'undefined' || index === -1) {
          return responseData;
        }

        responseData.filterData.filterItems.splice(index, 1);

        return responseData;
      }
    )).done((res) => {
      let pageData = res;
      pageData.data = mapping.blanks(res.data, params);

      $defaultSelectedBlankIds = res?.selectedBlankIds || [];

      App.pageData(
        'editArtworkBlanksIds',
        !params.reload ? [...$defaultSelectedBlankIds] : editArtworkBlanksIds
      );

      if (params && params.pagereload) {
        let template = require('./tmpl/partial/content.hbs');
        UI.render('#pageContentBlanks', template, pageData).then(() => {
          pageinit({ pagereload: true });
          App.pageData('selectBlanks', selectBlanks);
          App.pageData('selectBlanksAll', selectBlanksAll);
        });

        return;
      }

      if (params && params.action == 'dialog') {
        let selectAll = App.pageData('selectAll');
        App.pageData('blanks', res.data);
        pageData = {
          ...pageData,
          ...{
            dialog: true,
            callback: params.callback,
            reload: params.reload,
            query: query,
            $lang: $lang,
            selectAll: selectAll
          }
        };
        pageData.data.forEach((item) => {
          item.isDialog = true;
        });
        return dialogPage(pageData);
      }

      let template = require('./tmpl/blanks.hbs');
      UI.page(template, pageData).then(() => {
        pageinit(pageData);
        App.pageData('selectBlanks', selectBlanks);
        App.pageData('selectBlanksAll', selectBlanksAll);
      });
    });
  };

  let pageinit = (pageData) => {
    // Colors
    ColorVariants.init();

    //ZOOM-IN
    UI.zoomInInit('zoomimage');

    if (!pageData.dialog) {
      $('#page')
        .off()
        .on('click', '.js-action-assigntask', assignTask)
        .on('click', '.js-action-selectdeselect', selectDeselect)
        .on('click', '.js-action-approvereject', approveReject)
        .on('click', '.card-item-blanks .color-variants-morelink', dialogInfo)
        .on('click', '.card-item-blanks .model-images', modelImagesInfo)
        .on('dblclick', '.card-item-blanks .js-dialog-info', dialogInfo)
        .on('change', '.card-item-blanks .item-color-checkbox', updateBlankColor);
    }

    // Reload content
    if (pageData.pagereload) {
      UI.unblock('#page');
      return;
    }

    // In Dialog page
    if (pageData.dialog) {
      if (!pageData.reload) {
        SortFilter.init({
          selector: '#blanksSearchForm',
          pagename: 'blanks',
          update: reloadDialogWithClearingSelectAll
        });
      }

      Common.paginationDialog({
        paginationWraper: '#blanksCatalog',
        pagename: 'blanks',
        action: reloadDialog
      });

      //Reset to Artwork default selected blanks
      if ($('#resetDefaultBlanks').length) {
        $('#resetDefaultBlanks')
          .off()
          .on('click', () => {
            App.pageData('selectBlanksAll', false);
            App.pageData('editArtworkBlanksIds', [...$defaultSelectedBlankIds]);
            App.pageData('currenteditedcontent.isDetachedFromAccountBlanks', false);
            $isDetachedFromAccountBlanks = false;
          });
      }

      $('.modal-blanks-page .modal-body').scrollTop(0);
      UI.unblock('#page');
      return UI.unblock('.modal-content');
    }

    SortFilter.init({
      selector: '#blanksSearchForm',
      update: reloadPageWithClearingSelectAll
    });

    UI.unblock('#page');
  };

  let reloadPageWithClearingSelectAll = () => {
    App.pageData('selectBlanks', []);
    App.pageData('selectBlanksAll', false);
    reloadPage();
  };

  let reloadDialogWithClearingSelectAll = () => {
    //App.pageData('editArtworkBlanks', []);
    //App.pageData('selectBlanksAll', false);
    reloadDialog();
  };

  let reloadPage = () => {
    App.ajaxAbortAll();
    UI.block('#page');
    loadData({ pagereload: true });
  };

  let reloadDialog = (query = '') => {
    UI.block('.modal-content');
    loadData({
      action: 'dialog',
      reload: true,
      selectBlanks: App.pageData('editArtworkBlanksIds') || [],
      isDetachedFromAccountBlanks: $isDetachedFromAccountBlanks
    });
  };

  let reloadDialogInfo = (id) => {
    UI.block('.modal-content');
    BlankInfo.reloadDialog(id);
  };

  let dialogPage = (pageData) => {
    if (pageData.reload) {
      let editArtworkBlanksIds = App.pageData('editArtworkBlanksIds') || [];
      let template = require('./tmpl/partial/content.hbs');
      UI.render('#pageContentBlanks', template, pageData).then(() => {
        App.pageData('editArtworkBlanksIds', editArtworkBlanksIds);
        pageinit({ dialog: true, reload: true });
      });

      return;
    }

    let template = require('./tmpl/blanks.hbs');
    bootbox
      .dialog({
        title: $lang.artwork.Blanks,
        message: template(pageData),
        size: 'xl',
        className: 'modal-scrolled-content modal-blanks-page',
        onHide: (e) => {
          SortFilter.clear('blanks');
          pageData.callback(false);
        },
        buttons: {
          Ok: {
            label: `<span class="blanks-counter mx-4">${$lang.btn.applay}</span>`,
            attributes: [
              { name: 'bind-statement-disabled', val: 'thisElem.disabled=!#DT.editArtworkBlanksIds.length' },
              {
                name: 'bind-statement-text',
                val: "$(thisElem).find('.blanks-counter').text('Select ('+#DT.editArtworkBlanksIds.length+')')"
              }
            ],
            className: 'btn bbw-border-radius btn-danger',
            callback: () => pageData.callback(true)
          } /*,
        Close: {
          label: `${$lang.btn.cancel}`,
          className: 'btn btn-hover-dark bbw-border-radius'
        }*/
        }
      })
      .init(() => {
        pageinit({ dialog: true });
      });
  };

  let selectAll = (event) => {
    let dialog = $('#pagedialog').length && $('#pagedialog').val() == 1;

    let isCheked = $(event.currentTarget).prop('checked');
    App.pageData('selectBlanksAll', isCheked);

    if (!isCheked) {
      if (dialog) {
        App.pageData('editArtworkBlanksIds', []);
      } else {
        App.pageData('selectBlanks', []);
      }
      return;
    }

    let blockTarget = dialog ? '.modal-content' : '#page';

    UI.block(blockTarget);

    $.when(
      App.ajaxData(
        `blanks/select/all/${User.accountID()}`,
        { requestPage: 'blanks', isExcludeRejected: dialog },
        'POST'
      )
    )
      .done((res) => {
        if (dialog) {
          App.pageData('editArtworkBlanksIds', (res.data || []).map(b => b.id));
        } else {
          App.pageData('selectBlanks', res.data);
        }
      })
      .always(() => {
        UI.unblock(blockTarget);
      });
  };

  let updateBlankColor = (e, callback = false) => {
    let $elem = $(e.target);
    let blankId = $elem.data('entityid');
    let name = $elem.attr('name');
    let checked = $elem.prop('checked');
    let $parent = $elem.closest('.color-variants');

    if (!blankId || !$parent.length) {
      return;
    }

    let colors = [];
    $('.item-color-checkbox:checked', $parent).each(function () {
      colors.push($(this).attr('name'));
    });

    if (!colors.length) {
      return;
    }

    const request = {
      ItemId: blankId,
      AccountId: User.accountID(),
      SelectColorsName: colors
    };
    UI.blockPage();
    $.when(App.ajaxData('blanks/selectColors', request, 'POST')).done((res) => {
      if (!res.isSuccess) {
        $(`.item-color-checkbox[name=${name}]`, $parent).prop('checked', !checked);
        UI.unblockPage();
        return;
      }

      const result = Array.isArray(res.object) ? res.object : [res.object];
      const cItem = mapping.blanks(result)[0];

      // Update Item Color variants
      //ColorVariants.reload(cItem);

      if ($('.item-color-checkbox:checked', $parent).length == 1) {
        $('.item-color-checkbox:checked', $parent).prop('disabled', true);
      } else {
        $('.item-color-checkbox', $parent).prop('disabled', false);
      }

      if (callback) {
        callback();
      } else {
        let $imageElem = $('.img-bg-square', $(`[data-blankid=${blankId}]`));
        let $imageUrl = $('.item-color-checkbox:checked', $parent)
          .first()
          .closest('.kt-badge--bbw-color')
          .data('image');

        if ($imageUrl) {
          UI.zoomReInit($imageElem, $imageUrl);
        }
      }

      UI.unblockPage();
    });
  };

  let selectDeselect = () => {
    let selectBlanks = App.pageData('selectBlanks');
    if (!selectBlanks || !selectBlanks.length) {
      return;
    }

    let url = selectBlanks.every((b) => b.selectedStatusId == 2) ? 'blanks/deselect' : 'blanks/select';
    approveOrDisapprove(url, selectBlanks);
  };

  let approveOrDisapprove = (url, collection) => {
    UI.block('#page');
    let data = { AccountId: User.accountID(), Ids: {} };
    for (let i = 0; i < collection.length; i++) {
      let item = collection[i];
      data.Ids[item.id] = User.accountID();
    }
    $.when(App.ajaxData(url, data, 'POST'))
      .done((res) => {
        if (!res.isSuccess) {
          let txt =
            res.errorInformation && res.errorInformation.errorReason
              ? res.errorInformation.errorReason
              : 'Unknown error';
          UI.errorMessage(txt);
          UI.unblock('#page');
          return;
        }

        if (!res.confirmText) {
          UI.notify({ text: $lang.alert.SuccessfullySaved, type: 'success' });
          pageResetReload();
          return;
        }

        let infoData = res.value;

        if (!infoData?.length) {
          UI.notify({ text: res.confirmText, type: 'success' });
          pageResetReload();
          return;
        }

        infoData.$lang = $Lang;
        const template = require('./tmpl/dialog/deselectinfo-dialog.hbs');
        bootbox.dialog({
          title: $lang.blanks.DeselectDialogTitle,
          message: template(infoData),
          className: 'modal-scrolled-content',
          size: 'large',
          buttons: {
            ok: {
              label: $lang.btn.gotIt,
              className: 'btn btn-brand'
            }
          }
        });

        pageResetReload();
      })
      .catch((error) => {
        UI.unblock('#page');
      });
  };

  let pageResetReload = () => {
    App.pageData('selectBlanks', []);
    App.pageData('selectBlanksAll', false);
    reloadPage();
  };

  let dialogInfo = (e, isModelImagesInfo = false) => {
    if ($(e.target).closest('.kt-checkbox').length) {
      return;
    }
    let thisEl = $(e.target).hasClass('card-item') ? $(e.target) : $(e.target).closest('.card-item');
    let id = thisEl.data('itemid');

    if (!id) return alert('Blank not find');

    BlankInfo.dialog(id, reloadPage, false, isModelImagesInfo);
  };

  let modelImagesInfo = (e) => {
    dialogInfo(e, true);
  };

  let assignTask = (e) => {
    AssignTasks.handleAssignTask({
      e: e,
      elClassName: 'js-action-assigntask',
      selectedPageField: 'selectBlanks',
      requestPage: 1
    });
  };

  let approveReject = (e) => {
    let target = $(e.target).hasClass('js-action-approvereject')
      ? $(e.target)
      : $(e.target).closest('.js-action-approvereject');
    let id = target.data('itemid');

    const singleItem = id ? (App.pageData('blanks') || App.pageData('data') || []).find((i) => i.id == id) : null;
    const selectedItems = singleItem ? [singleItem] : App.pageData('selectBlanks');
    const mapped = selectedItems.reduce((acc, item) => ({ ...acc, [item.id]: User.accountID() }), {});

    ApprovalRejection.dialog({
      items: mapped,
      page: 'blanks',
      callback: () => {
        App.pageData('selectBlanks', []);
        App.pageData('selectBlanksAll', false);
        reloadPage();
      }
    });
  };

  /*
   * -   Unused
   * -   Old Approve / Reject Method
   */
  let approveBlanks = (id, clearSelectBlanks, allRejected, isDialog) => {
    let bulkApprove;
    if (allRejected) {
      bulkApprove = {
        items: clearSelectBlanks,
        comment: null,
        accountId: User.accountID(),
        approveType: $config.approveType.approved
      };
      if (isDialog) UI.block('.modal-content');
      else UI.block('#page');
      $.when(App.ajaxData('Blanks/bulk-approve', bulkApprove, 'PUT')).done(() => {
        if (isDialog) {
          reloadDialogInfo(id);
        } else {
          DT.selectBlanks = [];
          reloadPage();
        }
      });
    } else {
      bootbox.dialog({
        size: 'medium',
        title: $lang.btn.approveReject,
        value: null,
        message: `<label class="col-form-label brandbow-form-label"> ${$lang.blanks.Comments}</label><input type="text" id="comment" class="form-control brandbow-input"> `,
        buttons: {
          approve: {
            label: $lang.btn.approve,
            className: 'btn-approve',
            callback: function () {
              bulkApprove = {
                items: clearSelectBlanks,
                comment: null,
                accountId: User.accountID(),
                approveType: $config.approveType.approved
              };
              if (isDialog) UI.block('.modal-content');
              else UI.block('#page');

              $.when(App.ajaxData('Blanks/bulk-approve', bulkApprove, 'PUT')).done(() => {
                DT.data.forEach((item) => {
                  if (clearSelectBlanks.includes(item.id)) {
                    item.approveItem.approved = $config.approveType.approved;
                    item.approveItem.approvedName = $config.approveTypeName.approved;
                  }
                });

                if (isDialog) {
                  reloadDialogInfo(id);
                } else {
                  DT.selectBlanks = [];
                  reloadPage();
                }
              });
            }
          },
          reject: {
            label: $lang.btn.reject,
            className: 'btn-reject',
            callback: function () {
              return rejectBlanks(id, clearSelectBlanks, isDialog, $('#comment').val());
            }
          }
        }
      });
    }
  };

  let rejectBlanks = (id, clearSelectBlanks, isDialog, comment) => {
    let bulkApprove;
    let numberofMockups = 0;
    let ids = {
      items: clearSelectBlanks,
      nextAction: $config.itemRelatedProductsActionType.ConfirmMockups
    };
    if (isDialog) UI.block('.modal-content');
    else UI.block('#page');
    $needToPromptBulkApprove = false;
    $showCancelationNotice = false;

    $.when(App.ajaxData(`Blanks/delete-products`, ids, 'POST')).done((res) => {
      numberofMockups = res.data.mockupsCount;
      $showCancelationNotice = res.data.isSelected;
      let blankNames = res.data.processedAssetNames.join();

      if (numberofMockups > 0) {
        // Ask to delete mockups
        bootbox.confirm({
          message:
            $lang.blanks.ThisBlank +
            ' (' +
            blankNames +
            ') ' +
            $lang.blanks.Have +
            ' ' +
            numberofMockups +
            ' ' +
            $lang.blanks.AskRejectMockups,
          buttons: {
            confirm: {
              label: $lang.btn.yes,
              className: ''
            },
            cancel: {
              label: $lang.btn.no,
              className: ''
            }
          },
          callback: function (result) {
            $needToPromptBulkApprove = result;

            // if more than 0 mockups and result = true than delete
            if ($needToPromptBulkApprove) {
              ids.nextAction = $config.itemRelatedProductsActionType.DeleteMockups;
            } else {
              // If no mockups to delete, than cancel rejection
              if (isDialog) {
                UI.unblock('.modal-content');
              } else {
                DT.selectBlanks = [];
                UI.unblock('#page');
              }
              return;
            }
            $.when(App.ajaxData('Blanks/delete-products', ids, 'POST')).done(() => {
              ids.nextAction = $config.itemRelatedProductsActionType.ConfirmListings;

              $.when(App.ajaxData('Blanks/delete-products', ids, 'POST')).done((res) => {
                if (res.data.listingsCount == 0 && $needToPromptBulkApprove) {
                  bulkApprove = {
                    items: clearSelectBlanks,
                    comment: comment,
                    accountId: User.accountID(),
                    approveType: $config.approveType.disapproved
                  };
                  promptBulkApprove(id, bulkApprove, comment, isDialog);
                  DT.selectBlanks = [];
                  return;
                }

                let single = res.data.numberOfStores > 1 ? false : true;
                promptDeleteListings(id, clearSelectBlanks, res.data.listingsCount, single, comment, isDialog);
              });
            });
          }
        });
      } else {
        ids.nextAction = $config.itemRelatedProductsActionType.ConfirmListings;
        // Just disapprove when no connected mockups
        $.when(App.ajaxData('Blanks/delete-products', ids, 'POST')).done((res) => {
          if (res.data.listingsCount == 0) {
            bulkApprove = {
              items: clearSelectBlanks,
              comment: comment,
              accountId: User.accountID(),
              approveType: $config.approveType.disapproved
            };

            promptBulkApprove(id, bulkApprove, comment, isDialog);
            return;
          }

          let single = res.data.numberOfStores > 1 ? false : true;
          promptDeleteListings(id, clearSelectBlanks, res.data.listingsCount, single, comment, isDialog);
        });
      }
    });
  };

  let promptBulkApprove = (id, bulkApprove, comment, isDialog) => {
    if (comment !== undefined) {
      bulkApprove.comment = comment;
      bulkApprove.approveType = $config.approveType.disapproved;
      $.when(App.ajaxData('Blanks/bulk-approve', bulkApprove, 'PUT')).done(() => {
        if (isDialog) {
          reloadDialogInfo(id);
        } else {
          DT.selectBlanks = [];
          reloadPage();
        }

        if ($showCancelationNotice) {
          UI.notify({
            text: $lang.blanks.BlankWasCancelled,
            icon: 'fal fa-exclamation-circle',
            type: 'success'
          });
        }
      });
    } else {
      bootbox.prompt({
        size: 'medium',
        title: $lang.blanks.Comments,
        value: bulkApprove.comment,
        callback: function (result) {
          if (result == null) {
            if (isDialog) {
              $showCancelationNotice = false;
              UI.unblock('.modal-content');
            } else UI.unblock('#page');
            if ($showCancelationNotice) {
              UI.notify({
                text: $lang.blanks.BlankWasCancelled,
                icon: 'fal fa-exclamation-circle',
                type: 'success'
              });
            }
            return;
          }

          bulkApprove.comment = result;
          bulkApprove.approveType = $config.approveType.disapproved;
          $.when(App.ajaxData('Blanks/bulk-approve', bulkApprove, 'PUT')).done(() => {
            if (isDialog) {
              reloadDialogInfo(id);
            } else {
              DT.selectBlanks = [];
              reloadPage();
            }

            if ($showCancelationNotice) {
              UI.notify({
                text: $lang.blanks.BlankWasCancelled,
                icon: 'fal fa-exclamation-circle',
                type: 'success'
              });
            }
          });
        }
      });
    }
  };

  let clearApprovalRejection = (id, isDialog) => {
    let bulkApprove = {
      items: [id],
      comment: null,
      accountId: User.accountID(),
      approveType: $config.approveType.default
    };
    if (isDialog) UI.block('.modal-content');
    else UI.block('#page');
    $.when(App.ajaxData('/blanks/clearapprovalrejection', bulkApprove, 'POST')).done((res) => {
      if (isDialog) {
        reloadDialogInfo(id);
      } else {
        DT.selectBlanks = [];
        reloadPage();
      }
    });
  };

  let promptDeleteListings = (id, clearSelectBlanks, numberOfListings, single, comment, isDialog) => {
    let bulkApprove = {
      items: clearSelectBlanks,
      comment: null,
      accountId: User.accountID(),
      approveType: $config.approveType.disapproved
    };

    bootbox.confirm({
      message: $lang.blanks.ThisBlankHasRelated + ' ' + numberOfListings + ' ' + $lang.blanks.RejectProductsInStores,
      buttons: {
        confirm: {
          label: single == true ? $lang.btn.RemoveFromStore : $lang.btn.RemoveFromStores,
          className: ''
        },
        cancel: {
          label: single == true ? $lang.btn.keepInStore : $lang.btn.keepInStores,
          className: ''
        }
      },
      callback: function (resultProducts) {
        if (resultProducts == false) {
          promptBulkApprove(id, bulkApprove, comment, isDialog);

          return;
        }

        let ids = {
          items: clearSelectBlanks,
          nextAction: $config.itemRelatedProductsActionType.DeleteListings
        };

        $.when(App.ajaxData('Blanks/delete-products', ids, 'POST')).done(() => {
          promptBulkApprove(id, bulkApprove, comment, isDialog);
        });
      }
    });
  };

  /*
   * -   Unused
   */
  let deleteDialog = (id, title) => {
    bootbox.dialog({
      title: $lang.blanks.DeleteBlank,
      message: `<h5 class="text-danger">${$lang.alert.WantDelete} <b style="text-transform:capitalize">"${title}"</b>?</h5>`,
      className: 'modal-danger erroralert-dialog-modal',
      buttons: {
        Ok: {
          label: $lang.btn.delete,
          className: 'btn btn-danger',
          callback: function () {}
        },
        close: {
          label: $lang.btn.close,
          className: 'btn btn-default'
        }
      }
    });
  };

  let editPage = () => {
    let template = require('./tmpl/blanksEdit.hbs');
    UI.page(template, {}).then(editPageInit);
  };

  let editPageInit = () => {
    $('[data-switch=true]').bootstrapSwitch();

    // Tags input - Select2
    $('[name="meta"]').select2({
      placeholder: 'Add a tag',
      tags: true,
      tokenSeparators: [',']
    });

    // Cancel button event
    $('.action-button-cancel').on('click', (e) => {
      e.preventDefault();
      window.$nextRouter.push('/blanks');
    });

    // Save button event
    $('.action-button-save').on('click', (e) => {
      e.preventDefault();
      blanksFormSubmit();
    });

    UI.unblock('#page');
  };

  let blanksFormSubmit = () => {
    let $form = $('#blankEditForm');

    // Validate
    $form.validate({ rules: ValidationRules.blankDialogForm });
    if (!$form.valid()) return false;

    let formData = $form.serializeObject();
    //TODO check here how do we know add or edit?

    bootbox.alert('SAVING');
  };

  return {
    init,
    assignTask,
    selectAll,
    promptBulkApprove,
    promptDeleteListings,
    updateBlankColor,
  };
})();
